import { render, staticRenderFns } from "./BookingStepsFormContainer.vue?vue&type=template&id=6223816a&scoped=true"
import script from "./BookingStepsFormContainer.vue?vue&type=script&lang=js"
export * from "./BookingStepsFormContainer.vue?vue&type=script&lang=js"
import style0 from "./BookingStepsFormContainer.vue?vue&type=style&index=0&id=6223816a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6223816a",
  null
  
)

export default component.exports